"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blanketTheme = void 0;
var _designTokensReact = require("@smartsheet/design-tokens-react");
var _sdsThemeInternal = require("@smartsheet/sds-theme-internal");
const blanketTheme = (0, _sdsThemeInternal.themed)({
  background: {
    "lodestar-light": "#000000",
    //no token for lodestar color that's been used here (black)
    "ursa-light": (0, _designTokensReact.color)("color--background--neutral-inverse--stronger")
  },
  opacity: {
    "lodestar-light": 0.1,
    "ursa-light": 0.08
  }
});
exports.blanketTheme = blanketTheme;
//# sourceMappingURL=blanketTheme.js.map